var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "120px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "小区名称" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.areaName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "areaName", $$v)
                      },
                      expression: "childData.areaName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "楼宇" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.buildingName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "buildingName", $$v)
                      },
                      expression: "childData.buildingName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.houseCode,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "houseCode", $$v)
                      },
                      expression: "childData.houseCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.customerName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "customerName", $$v)
                      },
                      expression: "childData.customerName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间建筑面积" } },
                [
                  _c("el-input-number", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.houseArea,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "houseArea", $$v)
                      },
                      expression: "childData.houseArea"
                    }
                  }),
                  _vm._v(" m² ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "装修开始时间", prop: "beginDate" } },
                [
                  _c("el-date-picker", {
                    staticClass: "form-item-width",
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      type: "date",
                      placeholder: "装修开始时间"
                    },
                    on: { change: _vm.handleBeginDate },
                    model: {
                      value: _vm.childData.beginDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "beginDate", $$v)
                      },
                      expression: "childData.beginDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "装修拟结束时间", prop: "expectEndDate" } },
                [
                  _c("el-date-picker", {
                    staticClass: "form-item-width",
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      type: "date",
                      placeholder: "装修拟结束时间"
                    },
                    on: { change: _vm.handleEndDate },
                    model: {
                      value: _vm.childData.expectEndDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "expectEndDate", $$v)
                      },
                      expression: "childData.expectEndDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "账单费用明细" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "95%", "margin-bottom": "10px" },
                      attrs: {
                        data: _vm.list,
                        "element-loading-text": "数据正在加载中...",
                        border: "",
                        stripe: "",
                        fit: "",
                        "highlight-current-row": ""
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "收费标准名称" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.chargeStandardName))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "计费方式" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.chargeMathName))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "开始时间" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.beginDate))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "结束时间" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.expectEndDate))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "金额(元)" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.chargeMathName !== "每次单独输入"
                                  ? _c("span", [
                                      _vm._v(_vm._s(scope.row.amount))
                                    ])
                                  : _c("el-input-number", {
                                      attrs: {
                                        precision: 2,
                                        size: "mini",
                                        min: 0
                                      },
                                      model: {
                                        value: scope.row.amount,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "amount", $$v)
                                        },
                                        expression: "scope.row.amount"
                                      }
                                    })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "应收款" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.totalMoney,
                          callback: function($$v) {
                            _vm.totalMoney = $$v
                          },
                          expression: "totalMoney"
                        }
                      }),
                      _vm._v(" 元 ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "付款方式", prop: "paymentMethod" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          staticStyle: { width: "300px" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择付款方式"
                          },
                          on: { change: _vm.handlePaymentMethodSelect },
                          model: {
                            value: _vm.childData.paymentMethod,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "paymentMethod", $$v)
                            },
                            expression: "childData.paymentMethod"
                          }
                        },
                        _vm._l(_vm.payTypeOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: { label: item.dicName, value: item.dicValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "实收金额", prop: "amount" } },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-width",
                        attrs: { min: 0, precision: 2 },
                        on: { change: _vm.handleMoneyChange },
                        model: {
                          value: _vm.childData.amount,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "amount", $$v)
                          },
                          expression: "childData.amount"
                        }
                      }),
                      _vm._v(" 元 ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "找零" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.childData.change,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "change", $$v)
                          },
                          expression: "childData.change"
                        }
                      }),
                      _vm._v(" 元 ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收款日期", prop: "receiptDate" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "200px" },
                        attrs: {
                          type: "datetime",
                          placeholder: "请选择开始日期",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.childData.receiptDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiptDate", $$v)
                          },
                          expression: "childData.receiptDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "1200px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("charge-confirm", {
            attrs: {
              "confirm-data": _vm.childData,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }